var countdownDistance = distanceToTimestamp(pst.sameDayCountdownTime, pst.sameDaySkipMondays);

window.addEventListener('load', function(){
  fillProductPst();
  fillCartPst();
  fillPstDates();
  fillCartCountdown();
})

let productGrid = document.getElementById('ProductGridContainer');
if (productGrid) {
  productGrid.addEventListener('render', function(){
    fillProductPst();
    fillPstDates();
  });
}

window.updatePst = function() {
  fillProductPst();
  fillCartPst();
  fillPstDates();
  fillCartCountdown();
}

function fillProductPst(){
  // Fill promised ship time messages on products
  if (pst.sameDayShipMessage && countdownDistance > 0) {
    fillPst(
      '.ready-to-ship',
      pst.sameDayShipMessage
    )
  } else if (pst.readyToShipMessage) {
    fillPst(
      '.ready-to-ship',
      pst.readyToShipMessage
    )
  }

  if (pst.madeToOrderMessage) {
    fillPst(
      '.made-to-order',
      pst.madeToOrderMessage
    )
  }
}

function fillCartPst(){
  // Fill the cart promised ship time message
  if (pst.cartSameDayCountdownMessage && countdownDistance > 0) {
    fillPst(
      '.cart-items__pst.ready-to-ship',
      pst.cartSameDayCountdownMessage
    )
  } else if (pst.cartReadyToShipMessage) {
    fillPst(
      '.cart-items__pst.ready-to-ship',
      pst.cartReadyToShipMessage
    )
  }

  if (pst.cartMadeToOrderMessage) {
    fillPst(
      '.cart-items__pst.made-to-order',
      pst.cartMadeToOrderMessage
    )
  }
}

function fillPst(selector, content) {
  document.querySelectorAll(selector).forEach(x => {
    if (x.querySelector('.ship-msg')) {
      x.querySelector('.ship-msg').innerHTML = content;
    }
    x.classList.remove('loading')
  })
}

function fillPstDates(){
  // Fill promised ship date spans
  if (pst.readyToShipDays && document.querySelector(".pst_ready_to_ship_date")) {
    document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{
      x.innerHTML = calculatePromisedShipDate(pst.readyToShipDays)
    })
  }

  if (pst.madeToOrderDays && document.querySelector(".pst_made_to_order_date")) {
    document.querySelectorAll(".pst_made_to_order_date").forEach(x=>{
      x.innerHTML = calculatePromisedShipDate(pst.madeToOrderDays)
    })
  }
}

/*
* Cart same-day shipping countdown
*/
function fillCartCountdown() {
  let cartMessage = document.querySelector("#pst-banner-message, #pst-subtotal-message");

  if (pst.sameDayCountdownTime && cartMessage && cartMessage.querySelector(".countdown")) {
    if (cartMessage && countdownDistance > 0) {
      countdownTimer(
        cartMessage.querySelector(".countdown"),
        cartMessage.dataset.format,
        cartMessage.dataset.time,
        true
      );
  
    } else if (cartMessage.classList.contains("ready-to-ship")) {
      cartMessage.innerHTML = pst.cartReadyToShipMessage;
    } else {
      cartMessage.innerHTML = pst.cartMadeToOrderMessage;
    }
  }
}

/*
* Update messages when ajax cart is changed
*/
let mainCartItems = document.getElementById('main-cart-items');
if (mainCartItems) {
  mainCartItems.addEventListener("updateCartComplete", function () {
    getJSON('/cart.js').then(cart => {
      let cartStatus = 'ready-to-ship';
      countdownDistance = distanceToTimestamp(pst.sameDayCountdownTime, pst.sameDaySkipMondays);
      cart.items.forEach(function(line_item){
        let stock = pst.cartInventoryTotals[line_item.id].inventory_quantity;
        let div = document.querySelector('[data-cart-item="'+line_item.key+'"]');
        let pstDiv = div.querySelector('.cart-item__pst');
        if (!pstDiv) return;
        let pstMessage = pstDiv.querySelector('.ship-msg');
  
        if (stock <= pst.cartInventoryMinimum || line_item.quantity > stock) {
          cartStatus = 'made-to-order';
          pstDiv.classList.add('made-to-order');
          pstDiv.classList.remove('ready-to-ship');
          pstMessage.innerHTML = pst.madeToOrderMessage;
  
        } else if (countdownDistance > 0 && pst.sameDayShipMessage) {
          pstDiv.classList.add('ready-to-ship');
          pstDiv.classList.remove('made-to-order');
          pstMessage.innerHTML = pst.sameDayShipMessage;
  
        } else {
          pstDiv.classList.add('ready-to-ship');
          pstDiv.classList.remove('made-to-order');
          pstMessage.innerHTML = pst.readyToShipMessage;
        }
      })
      pst.cartStatus = cartStatus

      let cartMessage = document.querySelector("#pst-banner-message, #pst-subtotal-message");

      if (cartMessage && pst.cartStatus == 'ready-to-ship') {
        cartMessage.classList.add('ready-to-ship');
        cartMessage.classList.remove('made-to-order');

        if (countdownDistance > 0 ) {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartSameDayCountdownMessage;
        } else if (pst.cartReadyToShipMessage) {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartReadyToShipMessage;
        }

      } else if (cartMessage && pst.cartStatus == 'made-to-order') {
        cartMessage.classList.add('made-to-order');
        cartMessage.classList.remove('ready-to-ship');

        if (pst.cartMadeToOrderMessage) {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartMadeToOrderMessage;
        }

      }

      if (pst.sameDayCountdownTime) {
        if (countdownDistance > 0 && cartMessage.querySelector(".countdown")) {
          countdownTimer(
            cartMessage.querySelector(".countdown"),
            cartMessage.dataset.format,
            cartMessage.dataset.time,
            true
          );

        } else if (cartMessage.classList.contains("ready-to-ship")) {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartReadyToShipMessage;
        } else {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartMadeToOrderMessage;
        }
      }

      if (pst.readyToShipDays && document.querySelector(".pst_ready_to_ship_date")) {
        var readyToShipDate = calculatePromisedShipDate(pst.readyToShipDays);
        document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{x.innerHTML = readyToShipDate});
      }

      if (pst.madeToOrderDays && document.querySelector(".pst_made_to_order_date")) {
        var madeToOrderDate = calculatePromisedShipDate(pst.madeToOrderDays);
        document.querySelectorAll(".pst_made_to_order_date").forEach(x=>{x.innerHTML = madeToOrderDate});
      }

      if (cart.item_count == 0) cartMessage.classList.add('hidden');
    })

    async function getJSON(path) {
      const response = await fetch(path);
      return await response.json();
    }
  });
}

/*
* Checkout
*/
if (Shopify.Checkout && pst.checkoutStatus) {
  // Customer info page
  if (Shopify.Checkout.step == 'contact_information') {
    let pickUpInStoreField = document.getElementById('checkout_pick_up_in_store_selected')

    if (pickUpInStoreField) {
    sessionStorage.setItem('pick_up_in_store', pickUpInStoreField.value)

    pickUpInStoreField.addEventListener('change', (event) => {
      sessionStorage.setItem('pick_up_in_store', event.currentTarget.value)
      removeLinePst();
      appendLinePst();
      updatePst();
    })
  }
  }

  // Shipping method page
  // Prepend PST to the shipping method content
  if (Shopify.Checkout.step == 'shipping_method') {
    prependShippingPst();
  }

  // Every page except "Thank You" and "Order Status"
  // Append line item PST and fill date/time
  if (Shopify.Checkout.page != 'thank_you' && !Shopify.Checkout.OrderStatus) {
    appendLinePst();
    updatePst();
  }

  if (Shopify.Checkout.step == 'contact_information' || Shopify.Checkout.step == 'shipping_method' || Shopify.Checkout.step == 'payment_method') {
    if (countdownDistance > 0 && pst.checkoutStatus == 'ready-to-ship') {
      sessionStorage.setItem('pstDate', calculatePromisedShipDate(0, 'ISO'));
    } else if (pst.checkoutStatus == 'ready-to-ship') {
      sessionStorage.setItem('pstDate', calculatePromisedShipDate(pst.readyToShipDays, 'ISO'));
    } else {
      sessionStorage.setItem('pstDate', calculatePromisedShipDate(pst.madeToOrderDays, 'ISO'));
    }
  }

  // Thank you page (first time visit)
  // Update PST metafield and display current PST
  if ( Shopify.Checkout.page == 'thank_you' ) {

    if (!!sessionStorage.getItem('pstDate')) {
      pst.confirmShipDate = sessionStorage.getItem('pstDate');
    } else if (countdownDistance > 0 && pst.checkoutStatus == 'ready-to-ship') {
      pst.confirmShipDate = calculatePromisedShipDate(0, 'ISO');
    } else if (pst.checkoutStatus == 'ready-to-ship') {
      pst.confirmShipDate = calculatePromisedShipDate(pst.readyToShipDays, 'ISO');
    } else {
      pst.confirmShipDate = calculatePromisedShipDate(pst.madeToOrderDays, 'ISO');
    }

    fetch('https://n8n.jnkbr.co/webhook/f16e16d0-e9fd-43df-84c4-cc7656129df8', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        promised_ship_date: pst.confirmShipDate,
        order_id: pst.orderId
      })
    }).then((response) => {
      let p = document.createElement('p');
      p.classList.add('section__text', 'pst-message');
      if (pst.checkoutStatus == 'ready-to-ship') {
        p.innerHTML = pst.readyToShipMessage;
      } else {
        p.innerHTML = pst.madeToOrderMessage;
      }
      let div = document.createElement('div');
      div.classList.add('section__message');
      div.append(p);

      document.querySelector('.section__content').prepend(div);

      if (countdownDistance > 0 && document.querySelector(".pst_ready_to_ship_date")) {
        var readyToShipDate = calculatePromisedShipDate(0);
        document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{x.innerHTML = readyToShipDate});
      }
      if (pst.readyToShipDays && document.querySelector(".pst_ready_to_ship_date")) {
        var readyToShipDate = calculatePromisedShipDate(pst.readyToShipDays);
        document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{x.innerHTML = readyToShipDate});
      }
      if (pst.madeToOrderDays && document.querySelector(".pst_made_to_order_date")) {
        var madeToOrderDate = calculatePromisedShipDate(pst.madeToOrderDays);
        document.querySelectorAll(".pst_made_to_order_date").forEach(x=>{x.innerHTML = madeToOrderDate});
      }

      sessionStorage.removeItem('pstDate');
    })
  }

  // Order status page
  // Prepend PST from order metafield (date retrieved in order-confirmation-scripts)
  if (Shopify.Checkout.OrderStatus && Shopify.Checkout.page != 'thank_you') {
    if (order.metafields.promised_ship_date) {
      let p = document.createElement('p');
      p.classList.add('section__text', 'pst-message');
      p.innerHTML = pst.orderConfirmationMessage;

      let div = document.createElement('div');
      div.classList.add('section__message');
      div.append(p);

      document.querySelector('.section__content').prepend(div);

      if (document.querySelector('.pst_date')) {
        let pstDate = (order.metafields.promised_ship_date.getMonth() + 1) + '/' + order.metafields.promised_ship_date.getDate();
        document.querySelectorAll('.pst_date').forEach(x=>{x.innerHTML = pstDate});
      }
    }

    sessionStorage.removeItem('pstDate');
  }

  // Checkout PST functions
  const contentObserver = new MutationObserver(()=>{
    if (Shopify.Checkout.step == 'shipping_method') {
      prependShippingPst();
      updatePst();
    }
  })

  contentObserver.observe(
    document.querySelector('.main__content'), {
      childList: true
    }
  )

  const lineObserver = new MutationObserver(()=>{
    appendLinePst();
    updatePst();
  })

  lineObserver.observe(
    document.querySelector('.order-summary__sections'), {
      childList: true
    }
  )

  function removeLinePst() {
    document.querySelector('.total-line--shipping-message').remove();
  }

  function appendLinePst(){
    let td = document.createElement('td');
    td.classList.add('total-line__name');
    td.setAttribute('colspan', '2');
    if (sessionStorage.getItem('pick_up_in_store') == 'true') {
      if (countdownDistance > 0 ) {
        td.innerHTML = pst.readyToPickUpMessage;
      }
      if (pst.checkoutStatus == 'ready-to-ship' && countdownDistance > 0) {
        td.innerHTML = pst.sameDayPickUpMessage;
      } else if (pst.checkoutStatus == 'ready-to-ship') {
        td.innerHTML = pst.readyToPickUpMessage;
      } else {
        td.innerHTML = pst.madeToOrderPickUpMessage;
      }
    } else {
      if (countdownDistance > 0 ) {
        td.innerHTML = pst.readyToShipMessage;
      }
      if (pst.checkoutStatus == 'ready-to-ship' && countdownDistance > 0) {
        td.innerHTML = pst.sameDayShipMessage;
      } else if (pst.checkoutStatus == 'ready-to-ship') {
        td.innerHTML = pst.readyToShipMessage;
      } else {
        td.innerHTML = pst.madeToOrderMessage;
      }
    }
    let tr = document.createElement('tr');
    tr.classList.add('total-line', 'total-line--shipping-message', 'pst-message');
    tr.append(td);

    if (!(document.querySelector('.total-line.total-line--shipping.pst-message'))) {
      document.querySelector('.total-line.total-line--shipping').parentNode.append(tr);
    }
  }

  function prependShippingPst(){
    let p = document.createElement('p');
    p.classList.add('section__text', 'pst-message');
    if (pst.checkoutStatus == 'ready-to-ship' && countdownDistance > 0) {
      p.classList.add('ready-to-ship');
      p.innerHTML = pst.sameDayShipMessage;
    } else if (pst.checkoutStatus == 'ready-to-ship') {
      p.classList.add('ready-to-ship');
      p.innerHTML = pst.readyToShipMessage;
    } else {
      p.innerHTML = pst.madeToOrderMessage;
    }

    let div = document.createElement('div');
    div.classList.add('section__message');
    div.append(p);

    if (!(document.querySelector('.section--shipping-method .section__message .pst-message'))) {
      document.querySelector('.section--shipping-method').prepend(div);
    };
  }

  function updatePst() {
    if (countdownDistance > 0 && document.querySelector(".pst-message .countdown")) {
      document.querySelectorAll('.pst-message .countdown').forEach((countdown) => {
        countdownTimer(
          countdown,
          pst.sameDayCountdownFormat,
          pst.sameDayCountdownTime,
          true
        )
      })
    }
    if (pst.readyToShipDays && document.querySelector(".pst_ready_to_ship_date")) {
      var readyToShipDate = calculatePromisedShipDate(pst.readyToShipDays);
      document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{x.innerHTML = readyToShipDate});
    }
    if (pst.madeToOrderDays && document.querySelector(".pst_made_to_order_date")) {
      var madeToOrderDate = calculatePromisedShipDate(pst.madeToOrderDays);
      document.querySelectorAll(".pst_made_to_order_date").forEach(x=>{x.innerHTML = madeToOrderDate});
    }
  }
}


/*
* Common functions
*/
function getStoreDateTime () {
  const localDate = new Date(); // local time
  const localOffset = localDate.getTimezoneOffset() * 60 * 1000; // local offset in milliseconds
  const utcTime = new Date(localDate.getTime() + localOffset); // calculated utc time
  const junkTime = new Date(utcTime.getTime() + theme.shopTimezoneOffset * 60 * 1000);
  return junkTime;
}

function calculatePromisedShipDate(days, format = "short") {
  function formatDate(date) {
    if (format == "ISO") {
      /* ISO Format is used for systems -- 2022-04-20 */
      return date.getFullYear() + "-" + addLeadingZero(date.getMonth() + 1) + "-" + addLeadingZero(date.getDate());
    } else {
      /* Short format is for display -- 4/20 */
      return date.getMonth() + 1 + "/" + date.getDate();
    }
  }

  function addLeadingZero(number) {
    return ("0" + number).slice(-2);
  }

  var storeTime = getStoreDateTime();
  let calc = 0,
      shipTime = new Date(storeTime.getTime()),
      shipDate = shipTime.getFullYear() + "-" + ("0" + (shipTime.getMonth() + 1)).slice(-2) + "-" + ("0" + shipTime.getDate()).slice(-2)

  while (calc < days) {
    shipTime = new Date(shipTime.getTime() + 86400000); // add 1 day in milliseconds
    shipDate = shipTime.getFullYear() + "-" + ("0" + (shipTime.getMonth() + 1)).slice(-2) + "-" + ("0" + shipTime.getDate()).slice(-2);

    // Skips Sunday, Saturday and JUNK Holidays
    if (shipTime.getDay() !== 0
        && shipTime.getDay() !== 6
        && !theme?.storeHolidays.some((x) => x == shipDate)) {
      calc++;
    }
  }

  return formatDate(shipTime, format);
}

function distanceToTimestamp(time, skipMondays = false) {
  let currentTime = getStoreDateTime(),
      currentDate = currentTime.getFullYear() + "-" + ("0" + (currentTime.getMonth() + 1)).slice(-2) + "-" + ("0" + currentTime.getDate()).slice(-2),
      holidayCheck = theme?.storeHolidays?.some((x) => x == currentDate);

  // [0, 1, 6]
  if ([0, 6].includes(currentTime.getDay()) || holidayCheck || (skipMondays == true && currentTime.getDay() == 1)) {
    return 0;
  }
  let date = new Date(currentDate + "T" + time + ":00.000" + theme.shopTimezone);
  return date.getTime() - new Date().getTime();
}

function countdownTimer (element, format, dateString, partial = false) {
  if (partial) {
    let currentTime = getStoreDateTime(),
        currentDate = currentTime.getFullYear() + "-" + ("0" + (currentTime.getMonth() + 1)).slice(-2) + "-" + ("0" + currentTime.getDate()).slice(-2);
    dateString = new Date(currentDate + "T" + dateString + ":00.000" + theme.shopTimezone);
  }
  element.classList.add("loader-bar");
  // element: A valid object selector name, i.e. '.timer'
  // format: "full" (XX Hours XX Minutes XX Seconds) or "condensed" (XX:XX:XX)
  // dateString example: 2021-11-04T00:00:00.000-07:00

  function formatTime(input, format) {
    let hours = Math.floor(input / (1000 * 60 * 60)).toLocaleString("en-US", { minimumIntegerDigits: 2 });
    let minutes = Math.floor((input % (1000 * 60 * 60)) / (1000 * 60)).toLocaleString("en-US", { minimumIntegerDigits: 2 });
    let seconds = Math.floor((input % (1000 * 60)) / 1000).toLocaleString("en-US", { minimumIntegerDigits: 2 });

    if (format == "extended") {
      let hoursText = hours != "01" ? " hours " : " hour ";
      let minutesText = minutes != "01" ? " minutes " : " minute ";
      let secondsText = seconds != "01" ? " seconds" : " second";

      let hoursString = hours + hoursText;
      let minutesString = minutes + minutesText;
      let secondsString = seconds + secondsText;

      var output = hoursString + minutesString + secondsString;
    } else if (format == "standard") {
      let hoursText = hours != "01" ? " hours " : " hour ";
      let minutesText = minutes != "01" ? " minutes " : " minute ";
      let secondsText = seconds != "01" ? " seconds" : " second";

      let hoursString = parseInt(hours) > 0 ? hours + hoursText : "";
      let minutesString = parseInt(minutes) > 0 ? minutes + minutesText : "";
      let secondsString = parseInt(seconds) > 0 ? seconds + secondsText : "";

      var output = hoursString + minutesString + secondsString;
    } else if (format == "condensed") {
      var output = hours + ":" + minutes + ":" + seconds;
    }

    return output;
  };

  let countDownDate = new Date(dateString);
  let countDownDateTime = countDownDate.getTime();

  let updateTimer = setInterval(function () {
    let now = new Date().getTime();
    let distance = countDownDateTime - now > 0 ? countDownDateTime - now : 0;
    element.innerHTML = formatTime(distance, format);
    element.classList.remove("loader-bar");

    if (distance <= 0) {
      clearInterval(updateTimer);
    }
  }, 1000);
};